import { Link } from '@tanstack/react-router';

export const WikiBackLink = () => (
  <Link
    to="/people-wiki"
    className="self-start rounded-md text-xs text-foreground-subtle hover:text-foreground focus-ring"
  >
    ← Wiki
  </Link>
);
